/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedWorkspaceIdRouteRouteImport } from './routes/_authenticated/$workspaceId/route'
import { Route as AuthenticatedWorkspaceIdIndexRouteImport } from './routes/_authenticated/$workspaceId/index'
import { Route as AuthenticatedWorkspaceIdUsageIndexRouteImport } from './routes/_authenticated/$workspaceId/usage/index'
import { Route as AuthenticatedWorkspaceIdSettingsIndexRouteImport } from './routes/_authenticated/$workspaceId/settings/index'
import { Route as AuthenticatedWorkspaceIdActivityIndexRouteImport } from './routes/_authenticated/$workspaceId/activity/index'
import { Route as AuthenticatedWorkspaceIdSettingsContextRouteImport } from './routes/_authenticated/$workspaceId/settings/context'
import { Route as AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteImport } from './routes/_authenticated/$workspaceId/reviews/$folderId/route'
import { Route as AuthenticatedWorkspaceIdFilesDocIdIndexRouteImport } from './routes/_authenticated/$workspaceId/files/$docId/index'
import { Route as AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRouteImport } from './routes/_authenticated/$workspaceId/compare-documents/$comparisonId/index'

const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const authCallbackLazyRouteImport = createFileRoute('/(auth)/callback')()
const AuthenticatedAdminIndexLazyRouteImport = createFileRoute(
  '/_authenticated/admin/',
)()
const AuthenticatedAdminReferencesLazyRouteImport = createFileRoute(
  '/_authenticated/admin/references',
)()
const AuthenticatedAdminGeneralSettingsLazyRouteImport = createFileRoute(
  '/_authenticated/admin/general-settings',
)()
const AuthenticatedAdminAttributesLazyRouteImport = createFileRoute(
  '/_authenticated/admin/attributes',
)()
const AuthenticatedWorkspaceIdSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/settings',
)()
const AuthenticatedWorkspaceIdReviewsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/reviews',
)()
const AuthenticatedWorkspaceIdReviewsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/reviews/',
)()
const AuthenticatedWorkspaceIdKnowledgeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/knowledge/',
)()
const AuthenticatedWorkspaceIdHelpIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/help/',
)()
const AuthenticatedWorkspaceIdFilesIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/files/',
)()
const AuthenticatedWorkspaceIdAppsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/apps/',
)()
const AuthenticatedWorkspaceIdAgentIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/agent/',
)()
const AuthenticatedWorkspaceIdSettingsWorkspaceLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/workspace')()
const AuthenticatedWorkspaceIdSettingsVerificationsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/verifications')()
const AuthenticatedWorkspaceIdSettingsTopicActionsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/topic-actions')()
const AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/severity-variables')()
const AuthenticatedWorkspaceIdSettingsReferencesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/references')()
const AuthenticatedWorkspaceIdSettingsMetadatasLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/metadatas')()
const AuthenticatedWorkspaceIdSettingsMembersLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/settings/members',
)()
const AuthenticatedWorkspaceIdSettingsGraphsLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/settings/graphs',
)()
const AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/document-types')()
const AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/document-groups')()
const AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/capabilities')()
const AuthenticatedWorkspaceIdSettingsAttributesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/settings/attributes')()
const AuthenticatedWorkspaceIdSettingsActionsLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/settings/actions',
)()
const AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/files/$docId',
)()
const AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/reviews/$folderId/')()
const AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/reviews/$folderId/todo')()
const AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/reviews/$folderId/graphs')()
const AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/reviews/$folderId/files')()
const AuthenticatedWorkspaceIdFilesDocIdInformationLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/files/$docId/information')()
const AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/files/$docId/graphs',
)()
const AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/files/$docId/comments')()
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/reviews/$folderId/attributes')()
const AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/files/$docId/attributes')()
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/reviews/$folderId/attributes/',
  )()
const AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/files/$docId/attributes/')()
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId',
  )()
const AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/files/$docId/attributes/$componentId',
  )()

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const authCallbackLazyRoute = authCallbackLazyRouteImport
  .update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/callback.lazy').then((d) => d.Route))
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWorkspaceIdRouteRoute =
  AuthenticatedWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdminIndexLazyRoute =
  AuthenticatedAdminIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/index.lazy').then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdIndexRoute =
  AuthenticatedWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedAdminReferencesLazyRoute =
  AuthenticatedAdminReferencesLazyRouteImport.update({
    id: '/references',
    path: '/references',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/references.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdminGeneralSettingsLazyRoute =
  AuthenticatedAdminGeneralSettingsLazyRouteImport.update({
    id: '/general-settings',
    path: '/general-settings',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/general-settings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdminAttributesLazyRoute =
  AuthenticatedAdminAttributesLazyRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/attributes.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsRouteLazyRoute =
  AuthenticatedWorkspaceIdSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdReviewsRouteLazyRoute =
  AuthenticatedWorkspaceIdReviewsRouteLazyRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/reviews/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdReviewsIndexLazyRoute =
  AuthenticatedWorkspaceIdReviewsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/reviews/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute =
  AuthenticatedWorkspaceIdKnowledgeIndexLazyRouteImport.update({
    id: '/knowledge/',
    path: '/knowledge/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/knowledge/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdHelpIndexLazyRoute =
  AuthenticatedWorkspaceIdHelpIndexLazyRouteImport.update({
    id: '/help/',
    path: '/help/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/help/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdFilesIndexLazyRoute =
  AuthenticatedWorkspaceIdFilesIndexLazyRouteImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/files/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdAppsIndexLazyRoute =
  AuthenticatedWorkspaceIdAppsIndexLazyRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/apps/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdAgentIndexLazyRoute =
  AuthenticatedWorkspaceIdAgentIndexLazyRouteImport.update({
    id: '/agent/',
    path: '/agent/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/agent/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdUsageIndexRoute =
  AuthenticatedWorkspaceIdUsageIndexRouteImport.update({
    id: '/usage/',
    path: '/usage/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/usage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsIndexRoute =
  AuthenticatedWorkspaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any)
const AuthenticatedWorkspaceIdActivityIndexRoute =
  AuthenticatedWorkspaceIdActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/activity/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute =
  AuthenticatedWorkspaceIdSettingsWorkspaceLazyRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/workspace.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute =
  AuthenticatedWorkspaceIdSettingsVerificationsLazyRouteImport.update({
    id: '/verifications',
    path: '/verifications',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/verifications.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute =
  AuthenticatedWorkspaceIdSettingsTopicActionsLazyRouteImport.update({
    id: '/topic-actions',
    path: '/topic-actions',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/topic-actions.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute =
  AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRouteImport.update({
    id: '/severity-variables',
    path: '/severity-variables',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/severity-variables.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsReferencesLazyRoute =
  AuthenticatedWorkspaceIdSettingsReferencesLazyRouteImport.update({
    id: '/references',
    path: '/references',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/references.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute =
  AuthenticatedWorkspaceIdSettingsMetadatasLazyRouteImport.update({
    id: '/metadatas',
    path: '/metadatas',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/metadatas.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsMembersLazyRoute =
  AuthenticatedWorkspaceIdSettingsMembersLazyRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/members.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsGraphsLazyRoute =
  AuthenticatedWorkspaceIdSettingsGraphsLazyRouteImport.update({
    id: '/graphs',
    path: '/graphs',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/graphs.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute =
  AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRouteImport.update({
    id: '/document-types',
    path: '/document-types',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/document-types.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute =
  AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRouteImport.update({
    id: '/document-groups',
    path: '/document-groups',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/document-groups.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute =
  AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRouteImport.update({
    id: '/capabilities',
    path: '/capabilities',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/capabilities.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsAttributesLazyRoute =
  AuthenticatedWorkspaceIdSettingsAttributesLazyRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/settings/attributes.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSettingsActionsLazyRoute =
  AuthenticatedWorkspaceIdSettingsActionsLazyRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/actions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteImport.update({
    id: '/files/$docId',
    path: '/files/$docId',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/files/$docId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSettingsContextRoute =
  AuthenticatedWorkspaceIdSettingsContextRouteImport.update({
    id: '/context',
    path: '/context',
    getParentRoute: () => AuthenticatedWorkspaceIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/settings/context.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteImport.update({
    id: '/$folderId',
    path: '/$folderId',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsRouteLazyRoute,
  } as any)
const AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdIndexRoute =
  AuthenticatedWorkspaceIdFilesDocIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute,
  } as any)
const AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute =
  AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRouteImport.update({
    id: '/compare-documents/$comparisonId/',
    path: '/compare-documents/$comparisonId/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/compare-documents/$comparisonId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRouteImport.update({
    id: '/todo',
    path: '/todo',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/todo.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRouteImport.update({
    id: '/graphs',
    path: '/graphs',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/graphs.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/files.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdInformationLazyRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/information.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRouteImport.update({
    id: '/graphs',
    path: '/graphs',
    getParentRoute: () => AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/graphs.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRouteImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () => AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/comments.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/attributes/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/attributes/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/attributes/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/attributes/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute =
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRouteImport.update(
    {
      id: '/$componentId',
      path: '/$componentId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute =
  AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRouteImport.update(
    {
      id: '/$componentId',
      path: '/$componentId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/files/$docId/attributes/$componentId.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/logout': typeof LogoutRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/$workspaceId/reviews': typeof AuthenticatedWorkspaceIdReviewsRouteLazyRouteWithChildren
  '/$workspaceId/settings': typeof AuthenticatedWorkspaceIdSettingsRouteLazyRouteWithChildren
  '/admin/attributes': typeof AuthenticatedAdminAttributesLazyRoute
  '/admin/general-settings': typeof AuthenticatedAdminGeneralSettingsLazyRoute
  '/admin/references': typeof AuthenticatedAdminReferencesLazyRoute
  '/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/admin/': typeof AuthenticatedAdminIndexLazyRoute
  '/$workspaceId/reviews/$folderId': typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteWithChildren
  '/$workspaceId/settings/context': typeof AuthenticatedWorkspaceIdSettingsContextRoute
  '/$workspaceId/files/$docId': typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteWithChildren
  '/$workspaceId/settings/actions': typeof AuthenticatedWorkspaceIdSettingsActionsLazyRoute
  '/$workspaceId/settings/attributes': typeof AuthenticatedWorkspaceIdSettingsAttributesLazyRoute
  '/$workspaceId/settings/capabilities': typeof AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute
  '/$workspaceId/settings/document-groups': typeof AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute
  '/$workspaceId/settings/document-types': typeof AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute
  '/$workspaceId/settings/graphs': typeof AuthenticatedWorkspaceIdSettingsGraphsLazyRoute
  '/$workspaceId/settings/members': typeof AuthenticatedWorkspaceIdSettingsMembersLazyRoute
  '/$workspaceId/settings/metadatas': typeof AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute
  '/$workspaceId/settings/references': typeof AuthenticatedWorkspaceIdSettingsReferencesLazyRoute
  '/$workspaceId/settings/severity-variables': typeof AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute
  '/$workspaceId/settings/topic-actions': typeof AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute
  '/$workspaceId/settings/verifications': typeof AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute
  '/$workspaceId/settings/workspace': typeof AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute
  '/$workspaceId/activity': typeof AuthenticatedWorkspaceIdActivityIndexRoute
  '/$workspaceId/settings/': typeof AuthenticatedWorkspaceIdSettingsIndexRoute
  '/$workspaceId/usage': typeof AuthenticatedWorkspaceIdUsageIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/apps': typeof AuthenticatedWorkspaceIdAppsIndexLazyRoute
  '/$workspaceId/files': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/$workspaceId/help': typeof AuthenticatedWorkspaceIdHelpIndexLazyRoute
  '/$workspaceId/knowledge': typeof AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute
  '/$workspaceId/reviews/': typeof AuthenticatedWorkspaceIdReviewsIndexLazyRoute
  '/$workspaceId/files/$docId/attributes': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteWithChildren
  '/$workspaceId/reviews/$folderId/attributes': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteWithChildren
  '/$workspaceId/files/$docId/comments': typeof AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute
  '/$workspaceId/files/$docId/graphs': typeof AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute
  '/$workspaceId/files/$docId/information': typeof AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute
  '/$workspaceId/reviews/$folderId/files': typeof AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute
  '/$workspaceId/reviews/$folderId/graphs': typeof AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute
  '/$workspaceId/reviews/$folderId/todo': typeof AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute
  '/$workspaceId/compare-documents/$comparisonId': typeof AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute
  '/$workspaceId/files/$docId/': typeof AuthenticatedWorkspaceIdFilesDocIdIndexRoute
  '/$workspaceId/reviews/$folderId/': typeof AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute
  '/$workspaceId/files/$docId/attributes/$componentId': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute
  '/$workspaceId/reviews/$folderId/attributes/$componentId': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute
  '/$workspaceId/files/$docId/attributes/': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute
  '/$workspaceId/reviews/$folderId/attributes/': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute
}
export interface FileRoutesByTo {
  '/logout': typeof LogoutRoute
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/attributes': typeof AuthenticatedAdminAttributesLazyRoute
  '/admin/general-settings': typeof AuthenticatedAdminGeneralSettingsLazyRoute
  '/admin/references': typeof AuthenticatedAdminReferencesLazyRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdIndexRoute
  '/admin': typeof AuthenticatedAdminIndexLazyRoute
  '/$workspaceId/settings/context': typeof AuthenticatedWorkspaceIdSettingsContextRoute
  '/$workspaceId/settings/actions': typeof AuthenticatedWorkspaceIdSettingsActionsLazyRoute
  '/$workspaceId/settings/attributes': typeof AuthenticatedWorkspaceIdSettingsAttributesLazyRoute
  '/$workspaceId/settings/capabilities': typeof AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute
  '/$workspaceId/settings/document-groups': typeof AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute
  '/$workspaceId/settings/document-types': typeof AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute
  '/$workspaceId/settings/graphs': typeof AuthenticatedWorkspaceIdSettingsGraphsLazyRoute
  '/$workspaceId/settings/members': typeof AuthenticatedWorkspaceIdSettingsMembersLazyRoute
  '/$workspaceId/settings/metadatas': typeof AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute
  '/$workspaceId/settings/references': typeof AuthenticatedWorkspaceIdSettingsReferencesLazyRoute
  '/$workspaceId/settings/severity-variables': typeof AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute
  '/$workspaceId/settings/topic-actions': typeof AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute
  '/$workspaceId/settings/verifications': typeof AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute
  '/$workspaceId/settings/workspace': typeof AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute
  '/$workspaceId/activity': typeof AuthenticatedWorkspaceIdActivityIndexRoute
  '/$workspaceId/settings': typeof AuthenticatedWorkspaceIdSettingsIndexRoute
  '/$workspaceId/usage': typeof AuthenticatedWorkspaceIdUsageIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/apps': typeof AuthenticatedWorkspaceIdAppsIndexLazyRoute
  '/$workspaceId/files': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/$workspaceId/help': typeof AuthenticatedWorkspaceIdHelpIndexLazyRoute
  '/$workspaceId/knowledge': typeof AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute
  '/$workspaceId/reviews': typeof AuthenticatedWorkspaceIdReviewsIndexLazyRoute
  '/$workspaceId/files/$docId/comments': typeof AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute
  '/$workspaceId/files/$docId/graphs': typeof AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute
  '/$workspaceId/files/$docId/information': typeof AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute
  '/$workspaceId/reviews/$folderId/files': typeof AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute
  '/$workspaceId/reviews/$folderId/graphs': typeof AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute
  '/$workspaceId/reviews/$folderId/todo': typeof AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute
  '/$workspaceId/compare-documents/$comparisonId': typeof AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute
  '/$workspaceId/files/$docId': typeof AuthenticatedWorkspaceIdFilesDocIdIndexRoute
  '/$workspaceId/reviews/$folderId': typeof AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute
  '/$workspaceId/files/$docId/attributes/$componentId': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute
  '/$workspaceId/reviews/$folderId/attributes/$componentId': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute
  '/$workspaceId/files/$docId/attributes': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute
  '/$workspaceId/reviews/$folderId/attributes': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_authenticated/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/callback': typeof authCallbackLazyRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$workspaceId/reviews': typeof AuthenticatedWorkspaceIdReviewsRouteLazyRouteWithChildren
  '/_authenticated/$workspaceId/settings': typeof AuthenticatedWorkspaceIdSettingsRouteLazyRouteWithChildren
  '/_authenticated/admin/attributes': typeof AuthenticatedAdminAttributesLazyRoute
  '/_authenticated/admin/general-settings': typeof AuthenticatedAdminGeneralSettingsLazyRoute
  '/_authenticated/admin/references': typeof AuthenticatedAdminReferencesLazyRoute
  '/_authenticated/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId': typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteWithChildren
  '/_authenticated/$workspaceId/settings/context': typeof AuthenticatedWorkspaceIdSettingsContextRoute
  '/_authenticated/$workspaceId/files/$docId': typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteWithChildren
  '/_authenticated/$workspaceId/settings/actions': typeof AuthenticatedWorkspaceIdSettingsActionsLazyRoute
  '/_authenticated/$workspaceId/settings/attributes': typeof AuthenticatedWorkspaceIdSettingsAttributesLazyRoute
  '/_authenticated/$workspaceId/settings/capabilities': typeof AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute
  '/_authenticated/$workspaceId/settings/document-groups': typeof AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute
  '/_authenticated/$workspaceId/settings/document-types': typeof AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute
  '/_authenticated/$workspaceId/settings/graphs': typeof AuthenticatedWorkspaceIdSettingsGraphsLazyRoute
  '/_authenticated/$workspaceId/settings/members': typeof AuthenticatedWorkspaceIdSettingsMembersLazyRoute
  '/_authenticated/$workspaceId/settings/metadatas': typeof AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute
  '/_authenticated/$workspaceId/settings/references': typeof AuthenticatedWorkspaceIdSettingsReferencesLazyRoute
  '/_authenticated/$workspaceId/settings/severity-variables': typeof AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute
  '/_authenticated/$workspaceId/settings/topic-actions': typeof AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute
  '/_authenticated/$workspaceId/settings/verifications': typeof AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute
  '/_authenticated/$workspaceId/settings/workspace': typeof AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute
  '/_authenticated/$workspaceId/activity/': typeof AuthenticatedWorkspaceIdActivityIndexRoute
  '/_authenticated/$workspaceId/settings/': typeof AuthenticatedWorkspaceIdSettingsIndexRoute
  '/_authenticated/$workspaceId/usage/': typeof AuthenticatedWorkspaceIdUsageIndexRoute
  '/_authenticated/$workspaceId/agent/': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/_authenticated/$workspaceId/apps/': typeof AuthenticatedWorkspaceIdAppsIndexLazyRoute
  '/_authenticated/$workspaceId/files/': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/_authenticated/$workspaceId/help/': typeof AuthenticatedWorkspaceIdHelpIndexLazyRoute
  '/_authenticated/$workspaceId/knowledge/': typeof AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute
  '/_authenticated/$workspaceId/reviews/': typeof AuthenticatedWorkspaceIdReviewsIndexLazyRoute
  '/_authenticated/$workspaceId/files/$docId/attributes': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteWithChildren
  '/_authenticated/$workspaceId/reviews/$folderId/attributes': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteWithChildren
  '/_authenticated/$workspaceId/files/$docId/comments': typeof AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute
  '/_authenticated/$workspaceId/files/$docId/graphs': typeof AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute
  '/_authenticated/$workspaceId/files/$docId/information': typeof AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId/files': typeof AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId/graphs': typeof AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId/todo': typeof AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute
  '/_authenticated/$workspaceId/compare-documents/$comparisonId/': typeof AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute
  '/_authenticated/$workspaceId/files/$docId/': typeof AuthenticatedWorkspaceIdFilesDocIdIndexRoute
  '/_authenticated/$workspaceId/reviews/$folderId/': typeof AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute
  '/_authenticated/$workspaceId/files/$docId/attributes/$componentId': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute
  '/_authenticated/$workspaceId/files/$docId/attributes/': typeof AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute
  '/_authenticated/$workspaceId/reviews/$folderId/attributes/': typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/logout'
    | '/$workspaceId'
    | '/admin'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/$workspaceId/reviews'
    | '/$workspaceId/settings'
    | '/admin/attributes'
    | '/admin/general-settings'
    | '/admin/references'
    | '/$workspaceId/'
    | '/admin/'
    | '/$workspaceId/reviews/$folderId'
    | '/$workspaceId/settings/context'
    | '/$workspaceId/files/$docId'
    | '/$workspaceId/settings/actions'
    | '/$workspaceId/settings/attributes'
    | '/$workspaceId/settings/capabilities'
    | '/$workspaceId/settings/document-groups'
    | '/$workspaceId/settings/document-types'
    | '/$workspaceId/settings/graphs'
    | '/$workspaceId/settings/members'
    | '/$workspaceId/settings/metadatas'
    | '/$workspaceId/settings/references'
    | '/$workspaceId/settings/severity-variables'
    | '/$workspaceId/settings/topic-actions'
    | '/$workspaceId/settings/verifications'
    | '/$workspaceId/settings/workspace'
    | '/$workspaceId/activity'
    | '/$workspaceId/settings/'
    | '/$workspaceId/usage'
    | '/$workspaceId/agent'
    | '/$workspaceId/apps'
    | '/$workspaceId/files'
    | '/$workspaceId/help'
    | '/$workspaceId/knowledge'
    | '/$workspaceId/reviews/'
    | '/$workspaceId/files/$docId/attributes'
    | '/$workspaceId/reviews/$folderId/attributes'
    | '/$workspaceId/files/$docId/comments'
    | '/$workspaceId/files/$docId/graphs'
    | '/$workspaceId/files/$docId/information'
    | '/$workspaceId/reviews/$folderId/files'
    | '/$workspaceId/reviews/$folderId/graphs'
    | '/$workspaceId/reviews/$folderId/todo'
    | '/$workspaceId/compare-documents/$comparisonId'
    | '/$workspaceId/files/$docId/'
    | '/$workspaceId/reviews/$folderId/'
    | '/$workspaceId/files/$docId/attributes/$componentId'
    | '/$workspaceId/reviews/$folderId/attributes/$componentId'
    | '/$workspaceId/files/$docId/attributes/'
    | '/$workspaceId/reviews/$folderId/attributes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/logout'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/admin/attributes'
    | '/admin/general-settings'
    | '/admin/references'
    | '/$workspaceId'
    | '/admin'
    | '/$workspaceId/settings/context'
    | '/$workspaceId/settings/actions'
    | '/$workspaceId/settings/attributes'
    | '/$workspaceId/settings/capabilities'
    | '/$workspaceId/settings/document-groups'
    | '/$workspaceId/settings/document-types'
    | '/$workspaceId/settings/graphs'
    | '/$workspaceId/settings/members'
    | '/$workspaceId/settings/metadatas'
    | '/$workspaceId/settings/references'
    | '/$workspaceId/settings/severity-variables'
    | '/$workspaceId/settings/topic-actions'
    | '/$workspaceId/settings/verifications'
    | '/$workspaceId/settings/workspace'
    | '/$workspaceId/activity'
    | '/$workspaceId/settings'
    | '/$workspaceId/usage'
    | '/$workspaceId/agent'
    | '/$workspaceId/apps'
    | '/$workspaceId/files'
    | '/$workspaceId/help'
    | '/$workspaceId/knowledge'
    | '/$workspaceId/reviews'
    | '/$workspaceId/files/$docId/comments'
    | '/$workspaceId/files/$docId/graphs'
    | '/$workspaceId/files/$docId/information'
    | '/$workspaceId/reviews/$folderId/files'
    | '/$workspaceId/reviews/$folderId/graphs'
    | '/$workspaceId/reviews/$folderId/todo'
    | '/$workspaceId/compare-documents/$comparisonId'
    | '/$workspaceId/files/$docId'
    | '/$workspaceId/reviews/$folderId'
    | '/$workspaceId/files/$docId/attributes/$componentId'
    | '/$workspaceId/reviews/$folderId/attributes/$componentId'
    | '/$workspaceId/files/$docId/attributes'
    | '/$workspaceId/reviews/$folderId/attributes'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/logout'
    | '/_authenticated/$workspaceId'
    | '/_authenticated/admin'
    | '/(auth)/sign-in'
    | '/(auth)/callback'
    | '/(auth)/forgot-password'
    | '/_authenticated/'
    | '/_authenticated/$workspaceId/reviews'
    | '/_authenticated/$workspaceId/settings'
    | '/_authenticated/admin/attributes'
    | '/_authenticated/admin/general-settings'
    | '/_authenticated/admin/references'
    | '/_authenticated/$workspaceId/'
    | '/_authenticated/admin/'
    | '/_authenticated/$workspaceId/reviews/$folderId'
    | '/_authenticated/$workspaceId/settings/context'
    | '/_authenticated/$workspaceId/files/$docId'
    | '/_authenticated/$workspaceId/settings/actions'
    | '/_authenticated/$workspaceId/settings/attributes'
    | '/_authenticated/$workspaceId/settings/capabilities'
    | '/_authenticated/$workspaceId/settings/document-groups'
    | '/_authenticated/$workspaceId/settings/document-types'
    | '/_authenticated/$workspaceId/settings/graphs'
    | '/_authenticated/$workspaceId/settings/members'
    | '/_authenticated/$workspaceId/settings/metadatas'
    | '/_authenticated/$workspaceId/settings/references'
    | '/_authenticated/$workspaceId/settings/severity-variables'
    | '/_authenticated/$workspaceId/settings/topic-actions'
    | '/_authenticated/$workspaceId/settings/verifications'
    | '/_authenticated/$workspaceId/settings/workspace'
    | '/_authenticated/$workspaceId/activity/'
    | '/_authenticated/$workspaceId/settings/'
    | '/_authenticated/$workspaceId/usage/'
    | '/_authenticated/$workspaceId/agent/'
    | '/_authenticated/$workspaceId/apps/'
    | '/_authenticated/$workspaceId/files/'
    | '/_authenticated/$workspaceId/help/'
    | '/_authenticated/$workspaceId/knowledge/'
    | '/_authenticated/$workspaceId/reviews/'
    | '/_authenticated/$workspaceId/files/$docId/attributes'
    | '/_authenticated/$workspaceId/reviews/$folderId/attributes'
    | '/_authenticated/$workspaceId/files/$docId/comments'
    | '/_authenticated/$workspaceId/files/$docId/graphs'
    | '/_authenticated/$workspaceId/files/$docId/information'
    | '/_authenticated/$workspaceId/reviews/$folderId/files'
    | '/_authenticated/$workspaceId/reviews/$folderId/graphs'
    | '/_authenticated/$workspaceId/reviews/$folderId/todo'
    | '/_authenticated/$workspaceId/compare-documents/$comparisonId/'
    | '/_authenticated/$workspaceId/files/$docId/'
    | '/_authenticated/$workspaceId/reviews/$folderId/'
    | '/_authenticated/$workspaceId/files/$docId/attributes/$componentId'
    | '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId'
    | '/_authenticated/$workspaceId/files/$docId/attributes/'
    | '/_authenticated/$workspaceId/reviews/$folderId/attributes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/callback': {
      id: '/(auth)/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof authCallbackLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$workspaceId': {
      id: '/_authenticated/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/$workspaceId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexLazyRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/$workspaceId/': {
      id: '/_authenticated/$workspaceId/'
      path: '/'
      fullPath: '/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/admin/references': {
      id: '/_authenticated/admin/references'
      path: '/references'
      fullPath: '/admin/references'
      preLoaderRoute: typeof AuthenticatedAdminReferencesLazyRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/general-settings': {
      id: '/_authenticated/admin/general-settings'
      path: '/general-settings'
      fullPath: '/admin/general-settings'
      preLoaderRoute: typeof AuthenticatedAdminGeneralSettingsLazyRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/attributes': {
      id: '/_authenticated/admin/attributes'
      path: '/attributes'
      fullPath: '/admin/attributes'
      preLoaderRoute: typeof AuthenticatedAdminAttributesLazyRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/$workspaceId/settings': {
      id: '/_authenticated/$workspaceId/settings'
      path: '/settings'
      fullPath: '/$workspaceId/settings'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/reviews': {
      id: '/_authenticated/$workspaceId/reviews'
      path: '/reviews'
      fullPath: '/$workspaceId/reviews'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/reviews/': {
      id: '/_authenticated/$workspaceId/reviews/'
      path: '/'
      fullPath: '/$workspaceId/reviews/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/knowledge/': {
      id: '/_authenticated/$workspaceId/knowledge/'
      path: '/knowledge'
      fullPath: '/$workspaceId/knowledge'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdKnowledgeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/help/': {
      id: '/_authenticated/$workspaceId/help/'
      path: '/help'
      fullPath: '/$workspaceId/help'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdHelpIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/files/': {
      id: '/_authenticated/$workspaceId/files/'
      path: '/files'
      fullPath: '/$workspaceId/files'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/apps/': {
      id: '/_authenticated/$workspaceId/apps/'
      path: '/apps'
      fullPath: '/$workspaceId/apps'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAppsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent/': {
      id: '/_authenticated/$workspaceId/agent/'
      path: '/agent'
      fullPath: '/$workspaceId/agent'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/usage/': {
      id: '/_authenticated/$workspaceId/usage/'
      path: '/usage'
      fullPath: '/$workspaceId/usage'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdUsageIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/settings/': {
      id: '/_authenticated/$workspaceId/settings/'
      path: '/'
      fullPath: '/$workspaceId/settings/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/activity/': {
      id: '/_authenticated/$workspaceId/activity/'
      path: '/activity'
      fullPath: '/$workspaceId/activity'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdActivityIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/settings/workspace': {
      id: '/_authenticated/$workspaceId/settings/workspace'
      path: '/workspace'
      fullPath: '/$workspaceId/settings/workspace'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsWorkspaceLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/verifications': {
      id: '/_authenticated/$workspaceId/settings/verifications'
      path: '/verifications'
      fullPath: '/$workspaceId/settings/verifications'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsVerificationsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/topic-actions': {
      id: '/_authenticated/$workspaceId/settings/topic-actions'
      path: '/topic-actions'
      fullPath: '/$workspaceId/settings/topic-actions'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsTopicActionsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/severity-variables': {
      id: '/_authenticated/$workspaceId/settings/severity-variables'
      path: '/severity-variables'
      fullPath: '/$workspaceId/settings/severity-variables'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/references': {
      id: '/_authenticated/$workspaceId/settings/references'
      path: '/references'
      fullPath: '/$workspaceId/settings/references'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsReferencesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/metadatas': {
      id: '/_authenticated/$workspaceId/settings/metadatas'
      path: '/metadatas'
      fullPath: '/$workspaceId/settings/metadatas'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsMetadatasLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/members': {
      id: '/_authenticated/$workspaceId/settings/members'
      path: '/members'
      fullPath: '/$workspaceId/settings/members'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsMembersLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/graphs': {
      id: '/_authenticated/$workspaceId/settings/graphs'
      path: '/graphs'
      fullPath: '/$workspaceId/settings/graphs'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsGraphsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/document-types': {
      id: '/_authenticated/$workspaceId/settings/document-types'
      path: '/document-types'
      fullPath: '/$workspaceId/settings/document-types'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/document-groups': {
      id: '/_authenticated/$workspaceId/settings/document-groups'
      path: '/document-groups'
      fullPath: '/$workspaceId/settings/document-groups'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/capabilities': {
      id: '/_authenticated/$workspaceId/settings/capabilities'
      path: '/capabilities'
      fullPath: '/$workspaceId/settings/capabilities'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/attributes': {
      id: '/_authenticated/$workspaceId/settings/attributes'
      path: '/attributes'
      fullPath: '/$workspaceId/settings/attributes'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsAttributesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/settings/actions': {
      id: '/_authenticated/$workspaceId/settings/actions'
      path: '/actions'
      fullPath: '/$workspaceId/settings/actions'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsActionsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/files/$docId': {
      id: '/_authenticated/$workspaceId/files/$docId'
      path: '/files/$docId'
      fullPath: '/$workspaceId/files/$docId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/settings/context': {
      id: '/_authenticated/$workspaceId/settings/context'
      path: '/context'
      fullPath: '/$workspaceId/settings/context'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSettingsContextRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId': {
      id: '/_authenticated/$workspaceId/reviews/$folderId'
      path: '/$folderId'
      fullPath: '/$workspaceId/reviews/$folderId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsRouteLazyRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/'
      path: '/'
      fullPath: '/$workspaceId/reviews/$folderId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute
    }
    '/_authenticated/$workspaceId/files/$docId/': {
      id: '/_authenticated/$workspaceId/files/$docId/'
      path: '/'
      fullPath: '/$workspaceId/files/$docId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute
    }
    '/_authenticated/$workspaceId/compare-documents/$comparisonId/': {
      id: '/_authenticated/$workspaceId/compare-documents/$comparisonId/'
      path: '/compare-documents/$comparisonId'
      fullPath: '/$workspaceId/compare-documents/$comparisonId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/todo': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/todo'
      path: '/todo'
      fullPath: '/$workspaceId/reviews/$folderId/todo'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/graphs': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/graphs'
      path: '/graphs'
      fullPath: '/$workspaceId/reviews/$folderId/graphs'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/files': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/files'
      path: '/files'
      fullPath: '/$workspaceId/reviews/$folderId/files'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute
    }
    '/_authenticated/$workspaceId/files/$docId/information': {
      id: '/_authenticated/$workspaceId/files/$docId/information'
      path: '/information'
      fullPath: '/$workspaceId/files/$docId/information'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdInformationLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute
    }
    '/_authenticated/$workspaceId/files/$docId/graphs': {
      id: '/_authenticated/$workspaceId/files/$docId/graphs'
      path: '/graphs'
      fullPath: '/$workspaceId/files/$docId/graphs'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute
    }
    '/_authenticated/$workspaceId/files/$docId/comments': {
      id: '/_authenticated/$workspaceId/files/$docId/comments'
      path: '/comments'
      fullPath: '/$workspaceId/files/$docId/comments'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/attributes': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/attributes'
      path: '/attributes'
      fullPath: '/$workspaceId/reviews/$folderId/attributes'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute
    }
    '/_authenticated/$workspaceId/files/$docId/attributes': {
      id: '/_authenticated/$workspaceId/files/$docId/attributes'
      path: '/attributes'
      fullPath: '/$workspaceId/files/$docId/attributes'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/attributes/': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/attributes/'
      path: '/'
      fullPath: '/$workspaceId/reviews/$folderId/attributes/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute
    }
    '/_authenticated/$workspaceId/files/$docId/attributes/': {
      id: '/_authenticated/$workspaceId/files/$docId/attributes/'
      path: '/'
      fullPath: '/$workspaceId/files/$docId/attributes/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute
    }
    '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId': {
      id: '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId'
      path: '/$componentId'
      fullPath: '/$workspaceId/reviews/$folderId/attributes/$componentId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute
    }
    '/_authenticated/$workspaceId/files/$docId/attributes/$componentId': {
      id: '/_authenticated/$workspaceId/files/$docId/attributes/$componentId'
      path: '/$componentId'
      fullPath: '/$workspaceId/files/$docId/attributes/$componentId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute
    }
  }
}

interface authRouteRouteChildren {
  authSignInRoute: typeof authSignInRoute
  authCallbackLazyRoute: typeof authCallbackLazyRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authSignInRoute: authSignInRoute,
  authCallbackLazyRoute: authCallbackLazyRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute
}

const AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteChildren: AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdAttributesComponentIdLazyRoute,
    AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdAttributesIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteChildren {
  AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute
  AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute
  AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute
  AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute
}

const AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteChildren: AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdAttributesRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdFilesLazyRoute,
    AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdGraphsLazyRoute,
    AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdTodoLazyRoute,
    AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteWithChildren =
  AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteChildren,
  )

interface AuthenticatedWorkspaceIdReviewsRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute: typeof AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteWithChildren
  AuthenticatedWorkspaceIdReviewsIndexLazyRoute: typeof AuthenticatedWorkspaceIdReviewsIndexLazyRoute
}

const AuthenticatedWorkspaceIdReviewsRouteLazyRouteChildren: AuthenticatedWorkspaceIdReviewsRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdReviewsFolderIdRouteRoute:
      AuthenticatedWorkspaceIdReviewsFolderIdRouteRouteWithChildren,
    AuthenticatedWorkspaceIdReviewsIndexLazyRoute:
      AuthenticatedWorkspaceIdReviewsIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdReviewsRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdReviewsRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdReviewsRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdSettingsRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdSettingsContextRoute: typeof AuthenticatedWorkspaceIdSettingsContextRoute
  AuthenticatedWorkspaceIdSettingsActionsLazyRoute: typeof AuthenticatedWorkspaceIdSettingsActionsLazyRoute
  AuthenticatedWorkspaceIdSettingsAttributesLazyRoute: typeof AuthenticatedWorkspaceIdSettingsAttributesLazyRoute
  AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute: typeof AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute
  AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute: typeof AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute
  AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute: typeof AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute
  AuthenticatedWorkspaceIdSettingsGraphsLazyRoute: typeof AuthenticatedWorkspaceIdSettingsGraphsLazyRoute
  AuthenticatedWorkspaceIdSettingsMembersLazyRoute: typeof AuthenticatedWorkspaceIdSettingsMembersLazyRoute
  AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute: typeof AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute
  AuthenticatedWorkspaceIdSettingsReferencesLazyRoute: typeof AuthenticatedWorkspaceIdSettingsReferencesLazyRoute
  AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute: typeof AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute
  AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute: typeof AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute
  AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute: typeof AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute
  AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute: typeof AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute
  AuthenticatedWorkspaceIdSettingsIndexRoute: typeof AuthenticatedWorkspaceIdSettingsIndexRoute
}

const AuthenticatedWorkspaceIdSettingsRouteLazyRouteChildren: AuthenticatedWorkspaceIdSettingsRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdSettingsContextRoute:
      AuthenticatedWorkspaceIdSettingsContextRoute,
    AuthenticatedWorkspaceIdSettingsActionsLazyRoute:
      AuthenticatedWorkspaceIdSettingsActionsLazyRoute,
    AuthenticatedWorkspaceIdSettingsAttributesLazyRoute:
      AuthenticatedWorkspaceIdSettingsAttributesLazyRoute,
    AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute:
      AuthenticatedWorkspaceIdSettingsCapabilitiesLazyRoute,
    AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute:
      AuthenticatedWorkspaceIdSettingsDocumentGroupsLazyRoute,
    AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute:
      AuthenticatedWorkspaceIdSettingsDocumentTypesLazyRoute,
    AuthenticatedWorkspaceIdSettingsGraphsLazyRoute:
      AuthenticatedWorkspaceIdSettingsGraphsLazyRoute,
    AuthenticatedWorkspaceIdSettingsMembersLazyRoute:
      AuthenticatedWorkspaceIdSettingsMembersLazyRoute,
    AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute:
      AuthenticatedWorkspaceIdSettingsMetadatasLazyRoute,
    AuthenticatedWorkspaceIdSettingsReferencesLazyRoute:
      AuthenticatedWorkspaceIdSettingsReferencesLazyRoute,
    AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute:
      AuthenticatedWorkspaceIdSettingsSeverityVariablesLazyRoute,
    AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute:
      AuthenticatedWorkspaceIdSettingsTopicActionsLazyRoute,
    AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute:
      AuthenticatedWorkspaceIdSettingsVerificationsLazyRoute,
    AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute:
      AuthenticatedWorkspaceIdSettingsWorkspaceLazyRoute,
    AuthenticatedWorkspaceIdSettingsIndexRoute:
      AuthenticatedWorkspaceIdSettingsIndexRoute,
  }

const AuthenticatedWorkspaceIdSettingsRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute
  AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute
}

const AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteChildren: AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdAttributesComponentIdLazyRoute,
    AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdAttributesIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute
  AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute
  AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute
  AuthenticatedWorkspaceIdFilesDocIdIndexRoute: typeof AuthenticatedWorkspaceIdFilesDocIdIndexRoute
}

const AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteChildren: AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdAttributesRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdCommentsLazyRoute,
    AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdGraphsLazyRoute,
    AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdInformationLazyRoute,
    AuthenticatedWorkspaceIdFilesDocIdIndexRoute:
      AuthenticatedWorkspaceIdFilesDocIdIndexRoute,
  }

const AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdRouteRouteChildren {
  AuthenticatedWorkspaceIdReviewsRouteLazyRoute: typeof AuthenticatedWorkspaceIdReviewsRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdSettingsRouteLazyRoute: typeof AuthenticatedWorkspaceIdSettingsRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdIndexRoute: typeof AuthenticatedWorkspaceIdIndexRoute
  AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute: typeof AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdActivityIndexRoute: typeof AuthenticatedWorkspaceIdActivityIndexRoute
  AuthenticatedWorkspaceIdUsageIndexRoute: typeof AuthenticatedWorkspaceIdUsageIndexRoute
  AuthenticatedWorkspaceIdAgentIndexLazyRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  AuthenticatedWorkspaceIdAppsIndexLazyRoute: typeof AuthenticatedWorkspaceIdAppsIndexLazyRoute
  AuthenticatedWorkspaceIdFilesIndexLazyRoute: typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  AuthenticatedWorkspaceIdHelpIndexLazyRoute: typeof AuthenticatedWorkspaceIdHelpIndexLazyRoute
  AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute: typeof AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute
  AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute: typeof AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute
}

const AuthenticatedWorkspaceIdRouteRouteChildren: AuthenticatedWorkspaceIdRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdReviewsRouteLazyRoute:
      AuthenticatedWorkspaceIdReviewsRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdSettingsRouteLazyRoute:
      AuthenticatedWorkspaceIdSettingsRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdIndexRoute: AuthenticatedWorkspaceIdIndexRoute,
    AuthenticatedWorkspaceIdFilesDocIdRouteLazyRoute:
      AuthenticatedWorkspaceIdFilesDocIdRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdActivityIndexRoute:
      AuthenticatedWorkspaceIdActivityIndexRoute,
    AuthenticatedWorkspaceIdUsageIndexRoute:
      AuthenticatedWorkspaceIdUsageIndexRoute,
    AuthenticatedWorkspaceIdAgentIndexLazyRoute:
      AuthenticatedWorkspaceIdAgentIndexLazyRoute,
    AuthenticatedWorkspaceIdAppsIndexLazyRoute:
      AuthenticatedWorkspaceIdAppsIndexLazyRoute,
    AuthenticatedWorkspaceIdFilesIndexLazyRoute:
      AuthenticatedWorkspaceIdFilesIndexLazyRoute,
    AuthenticatedWorkspaceIdHelpIndexLazyRoute:
      AuthenticatedWorkspaceIdHelpIndexLazyRoute,
    AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute:
      AuthenticatedWorkspaceIdKnowledgeIndexLazyRoute,
    AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute:
      AuthenticatedWorkspaceIdCompareDocumentsComparisonIdIndexRoute,
  }

const AuthenticatedWorkspaceIdRouteRouteWithChildren =
  AuthenticatedWorkspaceIdRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdRouteRouteChildren,
  )

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAttributesLazyRoute: typeof AuthenticatedAdminAttributesLazyRoute
  AuthenticatedAdminGeneralSettingsLazyRoute: typeof AuthenticatedAdminGeneralSettingsLazyRoute
  AuthenticatedAdminReferencesLazyRoute: typeof AuthenticatedAdminReferencesLazyRoute
  AuthenticatedAdminIndexLazyRoute: typeof AuthenticatedAdminIndexLazyRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAttributesLazyRoute:
      AuthenticatedAdminAttributesLazyRoute,
    AuthenticatedAdminGeneralSettingsLazyRoute:
      AuthenticatedAdminGeneralSettingsLazyRoute,
    AuthenticatedAdminReferencesLazyRoute:
      AuthenticatedAdminReferencesLazyRoute,
    AuthenticatedAdminIndexLazyRoute: AuthenticatedAdminIndexLazyRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedWorkspaceIdRouteRoute: typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedWorkspaceIdRouteRoute:
    AuthenticatedWorkspaceIdRouteRouteWithChildren,
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
